import { EditorObject } from '../models/editor-object.model';
import { ComponentNames } from './componentNames';
import { getComponentFromSource } from '../generics-helper/getComponentFromSource.generic';
import { IdentificationComponent } from '../models/components/commonComponents/IdentificationComponent';
import { compareObjectsForEquality } from './compareObjectsForEquality';

export function getDoorIdentifierNames(allDoors:EditorObject[],currentDoor:EditorObject): string[] {
    let identifiers = [];
    allDoors.forEach(obj => {
        // skip the same door object, no need to get the identification component for self comparison
        if(compareObjectsForEquality(currentDoor,obj)){
            return;
        }
        else{
            let idComp:IdentificationComponent = getComponentFromSource<IdentificationComponent>(ComponentNames.identificationComponent,obj.components);
            identifiers.push(idComp.userId);
        }       
    });

    return identifiers;
}